import { memo } from 'react';

import { SmartHome } from './SmartHome';
import { smartHomeScheme } from './internal/settings/smartHomeScheme';

export const SmartHomeContainer = memo(function SmartHomeContainer() {
  return <SmartHome scheme={smartHomeScheme} />;
});
